import { types } from 'mobx-state-tree'
import { simple_api_request } from '../api/simple_api_request'
import object_value from '../api/object_value'

// noinspection JSCheckFunctionSignatures
const BookExperienceStore = types.model({
  status: types.maybe(types.string),
  status_message: types.maybe(types.string),
  current_step: types.optional(types.number, 1),
  // steps: types.maybe(types.array),
  experience_id: types.maybe(types.number),
  event_id: types.maybe(types.number),
  number_guests: types.maybe(types.number)
}).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    set (key, value) {
      console.log('BookExperienceStore - set() - key, value:', key, value)
      self[key] = value
    },
    clean () {
      console.log('BookExperienceStore - clean()')
      self.status = null
      self.current_step = 1
      self.steps = [
        'Bedingungen für Gäste', // General
        'Bestätigung und Bezahlung'
      ]
      self.experience_id = null
      self.event_id = null
      self.number_guests = 1
      console.log('BookExperienceStore - clean() - cleaned self:', self)
    },
    restart_form () {
      console.log('BookExperienceStore - restart_form()')
      self.status = null
      self.current_step = 1
    },
    request (token, payment_obj) {
      const {
        experience_id,
        event_id,
        number_guests
      } = self

      const data = {
        experience_id,
        event_id,
        number_guests,
        ...payment_obj
      }

      self.status = 'loading'

      simple_api_request({
        path: '/api/experiences/book/',
        data,
        header_token: token
      }).then(
        self.process_response
      )
    },
    process_response (result) {
      console.log('BookExperienceStore - process_response() - result:', result)

      if (result.ok) {
        self.status = 'success'
      } else {
        let message = result.data.message
        let errors = object_value(result, 'data.errors', {})
        if (errors !== null && typeof errors === 'object') {
          for (let [key, value] of Object.entries(errors)) {
            if (value.length > 0) {
              let fetch_text = ''

              value.forEach(t => {
                fetch_text = fetch_text + t + '<br>'
              })

              message = message + `<br><strong>${key}</strong>:<br>${fetch_text}`
            }
          }
        }

        self.status = 'error'
        self.status_message = message
      }
    }
  })
)

export default BookExperienceStore



// WEBPACK FOOTER //
// ./src/stores/BookExperienceStore.js